<template>
  <div class="flex flex-col gap-5">
    <header class="flex flex-col gap-1 text-center">
      <h3 class="text-2xl font-semibold">{{ title }}</h3>
      <p class="text-sm text-gray-600" v-if="hasSubtitle">
        <slot name="subtitle">
          {{ subtitle }}
        </slot>
      </p>
    </header>
    <slot name="full"></slot>
    <div class="grid grid-cols-1 items-start gap-6 lg:grid-cols-3">
      <slot />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useSlots } from '#imports';
const slots = useSlots();
const props = defineProps<{
  title: string;
  subtitle?: string;
}>();
const hasSubtitle = props.subtitle || slots.subtitle;
</script>
